export default __webpack_public_path__ + "static/media/quiz_bg.f4a31547.png";